import { React } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import MenuMember from './MenuMember';

function NavBar({ isLogin }) {
    return (
        <nav class="navbar navbar-custom navbar-fixed-top">
            <div class="container">
                <div class="navbar-header">
                    <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#navbar-brand-centered">
                        <i class="fa fa-bars"></i>
                    </button>
                    <div class="navbar-brand navbar-brand-centered page-scroll">
                        <a href="/">
                            <img src="/assets/img/pet-logo.png" class="img-responsive" alt="" />
                        </a>
                    </div>
                </div>
                <div class="collapse navbar-collapse" id="navbar-brand-centered">
                    <ul class="nav navbar-nav">
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/about-us">About Us</Link></li>
                        <li><Link to="/services">Services</Link></li>
                    </ul>
                    <ul class="nav navbar-nav navbar-right">
                        {/* <li><Link to="#">Blog</Link></li> 
                        <li><Link to="/contact">Contact</Link></li>*/}
                        {!isLogin ? (
                            <li><Link class="login-btn" to="/member-login">Member Login</Link></li>
                        ) : (
                            <li><a className="membermenu"><MenuMember /></a></li>
                        )}                                                
                    </ul>
                </div>
            </div>
        </nav>
    )
}

const mapStateToProps = ({login: {isLogin}}) => ({
    isLogin
})
  
export default connect(mapStateToProps)(NavBar);